import * as dateFns from 'date-fns';

/**
 * Decompõe uma data com timezone, retornando um objeto `Date` que representa o
 * horário na região original como horário local (assim `date.getHours()`
 * retornará o horário original) e o offset de timezone.
 */
export function parseLocal(datetime: string) {
  let timePos = datetime.search(/[ T]/);
  let timezonePos = datetime.search(/([-+][\d:]+|Z)$/);
  if (timePos === -1 || timezonePos === -1 || timezonePos < timePos) {
    let date = dateFns.parseISO(datetime);
    return {
      date,
      timezoneOffset: date.getTimezoneOffset(),
    };
  }

  let localDatetime = datetime.slice(0, timezonePos);
  let timezone = datetime.slice(timezonePos);
  return {
    date: dateFns.parseISO(localDatetime),
    timezoneOffset: toTimezoneOffset(timezone),
  };
}

export function toTimezoneOffset(suffix: string) {
  if (suffix === 'Z') {
    return 0;
  }
  let match = /([-+])(\d?\d)(?::?(\d?\d)(?::00)?)?/.exec(suffix);
  if (!match) {
    return 0;
  }
  let sinal = match[1] === '-' ? -1 : 1;
  let horas = +match[2];
  let mins = +match[3] || 0;
  let secs = +match[4] || 0;
  return -sinal * (horas * 60 + mins + secs / 60);
}
